var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBedWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M456.834 224.933h-9.1v-105.5c0-30.418-24.748-55.166-55.168-55.166H119.434c-30.419 0-55.166 24.748-55.166 55.166v105.5h-9.102C24.747 224.933 0 249.68 0 280.1V432.734c0 8.284 6.716 15 15 15s15-6.716 15-15V415.6h452v17.134c0 8.284 6.716 15 15 15s15-6.716 15-15V280.1c0-30.42-24.747-55.167-55.166-55.167zm-362.566-105.5c0-13.876 11.289-25.166 25.166-25.166h273.133c13.878 0 25.168 11.29 25.168 25.166v105.5h-56.434a54.81 54.81 0 0 0 6.1-25.166V183.7c0-30.418-24.747-55.166-55.166-55.166H199.768c-30.42 0-55.168 24.748-55.168 55.166v16.067a54.81 54.81 0 0 0 6.1 25.166H94.268zm80.332 80.334V183.7c0-13.876 11.29-25.166 25.168-25.166h112.467c13.877 0 25.166 11.29 25.166 25.166v16.067c0 13.876-11.289 25.166-25.166 25.166H199.768c-13.878 0-25.168-11.29-25.168-25.166zM55.166 254.933H456.835c13.877 0 25.166 11.29 25.166 25.167v41.233H30V280.1c0-13.877 11.289-25.167 25.166-25.167zM30 351.333h452V385.6H30z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedWhite);
export default __webpack_public_path__ + "static/media/bedWHITE.e619fbeba12c4ab8b3dee7d12204e365.svg";
export { ForwardRef as ReactComponent };